import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PVExpire from '../ContentContainers/PVExpire';
//import { selectUserAccountId, selectUserIsRetail } from '../../../redux/userProfile/selectors';
import { selectUserIsRetail } from '../../../redux/userProfile/selectors';
import apiAxiosWebStore from '../../../helpers/apiAxiosWebStore';
import { refreshProfileMenus } from '../../../redux/userProfile/actionsAsync';
import PVGenericModal from '../ContentContainers/PVModals/PVGenericModal';

const PVAddToFavorite = ({
    apiRefreshProfileMenus,
    itemId,
    parentName,
    quantity,
    spinnerHasBeenClicked,
    enableControl,
    isUserRetail,
    favoriteListId
}) => {
    const initialState = {
        isError: false,
        isChkNewListName: false,
        isParentNameValid: false,
        isUpdating: false,
        showAddToFavoriteButton: true,
        showFavoriteLists: false,
        showSaveButton: false,
        showSuccess: false,
        errors: [],
        initialQuantity: quantity,
    };
    const maxNumberOfFavoriteListsAllowedForAccount = 10;
    const [ctrlStatus, setCtrlStatus] = useState(initialState);
    const [favoriteLists, setFavoriteLists] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalHeaderContents, setModalHeaderContents] = useState('header not set');
    const [modalBodyContents, setModalBodyContents] = useState('');
    const [modalResponse, setModalResponse] = useState(false);
    const [listId, setListId] = useState(0);
    const [enableSaveButtons, setEnableSaveButtons] = useState(false);
    const [chkNewListNameDisabled, setChkNewListNameDisabled] = useState(true);
    const [checkboxState, setCheckboxState] = useState([]);
    const [showOpenFavoritesSpinner, setShowOpenFavoritesSpinner] = useState(false);
    const [showCloseFavoritesSpinner, setShowCloseFavoritesSpinner] = useState(false);

    const initialNewListName = 'Enter list name';
    const [newListName, setNewListName] = useState(initialNewListName);

    const mainDiv = useRef(null);

    const [showButtonOnInitialRender] = useState(() => {
        if (parentName === `ProductList` || parentName === `Product Detail`) {
            return true;
        }
        return false;
    });

    const isDocumentClickOutsideThisComponent = (event) => {
        if (
            mainDiv === null ||
            mainDiv.current === null ||
            !mainDiv.current.contains(event.target)
        ) {
            setCtrlStatus({
                ...ctrlStatus,
                isUpdating: false,
                isChkNewListName: false,
                isError: false,
                showAddToFavoriteButton: true,
                showFavoriteLists: false,
            });
            setNewListName(initialNewListName);
            document.removeEventListener('click', isDocumentClickOutsideThisComponent);

            setCheckboxState([]);
            setEnableSaveButtons(false);
        }
    };

    const isNullOrWhitespace = (input) => {
        if (typeof input === 'undefined' || input == null) return true;

        return input.replace(/\s/g, '').length < 1;
    };

    const buildUrlForGetFavoriteLists = (inItemId) => {
        let apiUrl = `/favorites/itemId/${inItemId}`;
        apiUrl = encodeURI(apiUrl);
        return apiUrl;
    };

    const buildUrlForPutFavoriteLists = (inItemId, inItemQuantity, hasNewListName, inNewListName) => {
        let apiUrl = `/favorites/itemId/${inItemId}/${inItemQuantity}`;
        if (hasNewListName) {
            apiUrl = `${apiUrl}/${inNewListName}`;
        }
        apiUrl = encodeURI(apiUrl);
        return apiUrl;
    };

    const onClickBtnAddToFavorite = () => {
        setShowOpenFavoritesSpinner(true);
        setCtrlStatus({
            ...ctrlStatus,
            isUpdating: false,
            isError: false,
            showAddToFavoriteButton: false,
            errors: [],
        });

        const urlForGetFavoriteLists = buildUrlForGetFavoriteLists(itemId);

        apiAxiosWebStore
            .get(urlForGetFavoriteLists)
            .then((response) => {
                setFavoriteLists(response.data);
            })
            .then(() => {
                setShowOpenFavoritesSpinner(false);
                if (ctrlStatus.isError === false) {
                    setCtrlStatus({
                        ...ctrlStatus,
                        isUpdating: false,
                        showAddToFavoriteButton: false,
                        showFavoriteLists: true,
                    });
                }
                document.addEventListener('click', isDocumentClickOutsideThisComponent);
            })
            .catch((error) => {
                setShowOpenFavoritesSpinner(false);
                if (error.response.data.Errors !== undefined) {
                    let errorText = '';
                    for (let i = 0; i < error.response.data.Errors.length; i += 1) {
                        errorText += `${error.response.data.Errors[i].Description}\n`;
                    }
                    setModalHeaderContents('Add/Remove from My Favorites');
                    setModalBodyContents(errorText);
                    setModalIsOpen(true);
                } else {
                    setModalHeaderContents('Add/Remove from My Favorites');
                    setModalBodyContents(error.message);
                    setModalIsOpen(true);
                }
            });
    };

    const handleSaveButtons = () => {
        const somethingChanged = checkboxState.find((f) => f.originalChecked !== f.currentChecked);
        const enableSave = typeof somethingChanged !== 'undefined';
        setEnableSaveButtons(enableSave);
    };

    const upsertCheckboxState = (id, checked) => {
        const found = checkboxState.find((f) => f.id === id);
        //If not found
        if (typeof found === 'undefined') {
            const thisCheckbox = {
                id,
                originalChecked: !checked,
                currentChecked: checked,
            };
            //Insert
            setCheckboxState([...checkboxState, thisCheckbox]);
        } else {
            //Else update
            setCheckboxState(
                checkboxState.map((p) => (p.id === id ? { ...p, currentChecked: checked } : p))
            );
        }
    };

    const onChangeChkNewListName = (e) => {
        setCtrlStatus({
            ...ctrlStatus,
            isChkNewListName: e.target.checked,
            showFavoriteLists: true,
        });

        upsertCheckboxState(0, e.target.checked);
    };

    const onChangeNewListName = (e, itemID) => {
        setNewListName(e.target.value);
        const cb = $(`input[name='${itemID}chkNewListName']`);
        const hasValue = e.target.value.length > 0;
        cb.prop('checked', hasValue);
        setCtrlStatus({
            ...ctrlStatus,
            isChkNewListName: hasValue,
        });

        if (e.target.value.length === 1) {
            upsertCheckboxState(0, true);
        }

        if (e.target.value.length === 0) {
            upsertCheckboxState(0, false);
        }

        setChkNewListNameDisabled(!(e.target.value.length > 0));
    };

    const isNewListNameValid = () => {
        let isError = false;
        if (ctrlStatus.isChkNewListName === true) {
            if (isNullOrWhitespace(newListName)) {
                setModalHeaderContents('Add To Favorites');
                setModalBodyContents('Please enter name for new favorite list.');
                setModalIsOpen(true);
                return false;
            }

            if (newListName.trim().toLowerCase() === initialNewListName.trim().toLowerCase()) {
                setModalHeaderContents('Add To Favorites');
                setModalBodyContents(
                    `Name for new favorite list cannot be "${initialNewListName}".`
                );
                setModalIsOpen(true);
                return false;
            }

            favoriteLists.map((favoriteList) => {
                if (
                    isError === false &&
                    favoriteList.FavoriteList.ListName.trim().toLowerCase() ===
                        newListName.trim().toLowerCase()
                ) {
                    setModalHeaderContents('Add To Favorites');
                    setModalBodyContents(
                        'Name of new favorite list cannot be same as one already on file.'
                    );
                    setModalIsOpen(true);
                    isError = true;
                    setEnableSaveButtons(false);
                }
            });
        }
        if (isError === true) {
            return false;
        }
        return true;
    };

    const onChangeChkListName = (e, id) => {
        //see https://www.robinwieruch.de/react-update-item-in-list
        const newFavoriteLists = favoriteLists.map((favoriteList) => {
            if (favoriteList.FavoriteList.Id === id) {
                const updatedFavoriteList = {
                    ...favoriteList,
                    ContainsItem: !favoriteList.ContainsItem, //toggle value
                };
                return updatedFavoriteList;
            }
            return favoriteList;
        });

        setFavoriteLists(newFavoriteLists);

        upsertCheckboxState(id, e.target.checked);
    };

    const onClickSaveFavorites = () => {
        setShowCloseFavoritesSpinner(true);
        if (isNewListNameValid() === false) {
            return;
        }

        setCtrlStatus({
            ...ctrlStatus,
            isUpdating: true,
            isError: false,
            showSuccess: false,
            errors: [],
        });

        const urlForPutFavoriteLists = buildUrlForPutFavoriteLists(
            itemId,
            quantity,
            ctrlStatus.isChkNewListName,
            newListName
        );

        const body = JSON.stringify(favoriteLists);

        apiAxiosWebStore
            .put(urlForPutFavoriteLists, body)
            .then((response) => {
                setFavoriteLists(response.data.FavoriteListsForItemID);
                setListId(response.data.ListIdModifiedForItemId);
            })
            .then(() => {
                setShowCloseFavoritesSpinner(false);
                if (ctrlStatus.isError === false) {
                    setCtrlStatus({
                        ...ctrlStatus,
                        isUpdating: false,
                        isChkNewListName: false,
                        isError: false,
                        showAddToFavoriteButton: true,
                        showFavoriteLists: false,
                        showSuccess: true,
                    });
                }
                setNewListName(initialNewListName);
            })
            .then(() => {
                apiAxiosWebStore.post('/menus/refresh', '').then(() => {
                    apiRefreshProfileMenus();
                });
                document.removeEventListener('click', isDocumentClickOutsideThisComponent);
            })
            .catch((error) => {
                setShowCloseFavoritesSpinner(false);
                if (error.response.data.Errors !== undefined) {
                    let errorText = '';
                    for (let i = 0; i < error.response.data.Errors.length; i += 1) {
                        errorText += `${error.response.data.Errors[i].Description}\n`;
                    }
                    setModalHeaderContents('Add/Remove from My Favorites');
                    setModalBodyContents(errorText);
                    setModalIsOpen(true);
                } else {
                    setModalHeaderContents('Add/Remove from My Favorites');
                    setModalBodyContents(error.message);
                    setModalIsOpen(true);
                }

                setCtrlStatus({
                    ...ctrlStatus,
                    showAddToFavoriteButton: true,
                    showButtonOnInitialRender: true,
                    showFavoriteLists: false,
                    isUpdating: false,
                    isCheckNewListName: false,
                    isError: false,
                    errors: [],
                });
            });

        setCheckboxState([]);
        setEnableSaveButtons(false);
    };

    useEffect(() => {
        if (spinnerHasBeenClicked) {
            const quantityAsInt = parseInt(quantity)
            const newQuantity = isNaN(quantityAsInt) || quantityAsInt < 0 ? 0 : quantity;
            const apiUrl = `/favorites/updateQuantity/${favoriteListId}/${itemId}/${newQuantity}`;
            apiAxiosWebStore.get(apiUrl)
                //.then((response) => {
                //    if (response.data.Success) {
                //        console.log("Success");
                //    } else {
                //        console.log("Failure: " + response.data.Message);
                //    }
                //})
                //.catch((error) => {
                //    console.log("Failure");
                //});
        }
    }, [quantity]);

    useEffect(() => {
        document.addEventListener('click', isDocumentClickOutsideThisComponent);

        return () => {
            document.removeEventListener('click', isDocumentClickOutsideThisComponent);
        };
    }, []);

    //Enable or disable save buttons when checkbox state changes
    useEffect(() => {
        handleSaveButtons();
    }, [checkboxState]);

    return (
        <React.Fragment>
            {ctrlStatus.isUpdating ? (
                <div className="pv-spinner xs" />
            ) : (
                <React.Fragment>
                    {!isUserRetail && itemId !== undefined && itemId.length > 0 && (
                        <React.Fragment>
                            {ctrlStatus.showAddToFavoriteButton &&
                                (showButtonOnInitialRender || ctrlStatus.showSuccess) && (
                                    <div className="add-to-favorites single-add-to-cart">
                                        <button
                                            type="button"
                                            enabled={enableControl.toString()}
                                            className={`pv btn btn-primary btn-add-to-cart btn-add-to-favorites ${
                                                enableControl && !ctrlStatus.showSuccess
                                                    ? ''
                                                    : ' disabled'
                                            }`}
                                            onClick={() => {
                                                if (!ctrlStatus.showSuccess) {
                                                    onClickBtnAddToFavorite();
                                                }
                                            }}
                                        >
                                            Add To Favorites
                                        </button>
                                    </div>
                                )}
                            {showOpenFavoritesSpinner && (
                                <div className="pv-spinner xs" />
                            )}
                            {ctrlStatus.showFavoriteLists && !ctrlStatus.showSuccess && (
                                <React.Fragment>
                                    <PVGenericModal
                                        isOpen={modalIsOpen}
                                        setIsOpen={setModalIsOpen}
                                        acceptLabel="OK"
                                        cancelLabel="none"
                                        headerContents={modalHeaderContents}
                                        bodyContents={modalBodyContents}
                                        responseFunction={setModalResponse}
                                    />
                                    <div className="favoritesListPopup" ref={mainDiv}>
                                        <div>
                                            <h4>Add/Remove from My Favorites</h4>
                                            <p className="favoritesListPopup-instructions">
                                                Uncheck to remove item from My Favorites.
                                            </p>
                                        </div>
                                        <div>
                                            {ctrlStatus.showFavoriteLists && (
                                                <div className="single-add-to-cart btn-add-to-favorites">
                                                    <button
                                                        type="button"
                                                        disabled={enableSaveButtons ? undefined : true}
                                                        className={`pv btn btn-primary ${
                                                            enableSaveButtons ? '' : 'disabled'
                                                        }`}
                                                        onClick={() => {
                                                            onClickSaveFavorites();
                                                        }}
                                                    >
                                                        SAVE
                                                    </button>
                                                </div>
                                            )}
                                            {ctrlStatus.showFavoriteLists &&
                                                favoriteLists.length <
                                                    maxNumberOfFavoriteListsAllowedForAccount && (
                                                    <div className="pv-row">
                                                        <span className="pv-checkbox">
                                                            <input
                                                                id={itemId + 'chkNewListName'}
                                                                name={itemId + 'chkNewListName'}
                                                                type="checkbox"
                                                                value={ctrlStatus.isChkNewListName}
                                                                onChange={(e) =>
                                                                    onChangeChkNewListName(e)
                                                                }
                                                                disabled={chkNewListNameDisabled}
                                                            />
                                                            <label
                                                                htmlFor={itemId + 'chkNewListName'}
                                                            />
                                                            <input
                                                                id="txtNewListName"
                                                                name="txtNewListName"
                                                                type="text"
                                                                maxLength="50"
                                                                placeholder={initialNewListName}
                                                                onChange={(e) =>
                                                                    onChangeNewListName(e, itemId)
                                                                }
                                                            />
                                                        </span>
                                                    </div>
                                                )}
                                            {ctrlStatus.showFavoriteLists &&
                                                favoriteLists.map((favoriteList) => {
                                                    return (
                                                        <div
                                                            key={favoriteList.FavoriteList.Id}
                                                            className="pv-row"
                                                        >
                                                            <span className="pv-checkbox">
                                                                <input
                                                                    id={
                                                                        itemId +
                                                                        favoriteList.FavoriteList.Id
                                                                    }
                                                                    name={
                                                                        itemId +
                                                                        favoriteList.FavoriteList.Id
                                                                    }
                                                                    type="checkbox"
                                                                    checked={
                                                                        favoriteList.ContainsItem
                                                                    }
                                                                    onChange={(e) =>
                                                                        onChangeChkListName(
                                                                            e,
                                                                            favoriteList
                                                                                .FavoriteList.Id
                                                                        )
                                                                    }
                                                                />
                                                                <label
                                                                    htmlFor={
                                                                        itemId +
                                                                        favoriteList.FavoriteList.Id
                                                                    }
                                                                >
                                                                    {
                                                                        favoriteList.FavoriteList
                                                                            .ListName
                                                                    }
                                                                </label>
                                                            </span>
                                                        </div>
                                                    );
                                                })}
                                            {ctrlStatus.showFavoriteLists && (
                                                <div className="single-add-to-cart btn-add-to-favorites">
                                                    <button
                                                        type="button"
                                                        disabled={enableSaveButtons ? undefined : true}
                                                        className={`pv btn btn-primary ${
                                                            enableSaveButtons ? '' : 'disabled'
                                                        }`}
                                                        onClick={() => {
                                                            onClickSaveFavorites();
                                                        }}
                                                    >
                                                        SAVE
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                            {ctrlStatus.showSuccess && (
                                <PVExpire
                                    hidden={!ctrlStatus.showSuccess}
                                    expiresMs={10000}
                                    onComplete={() =>
                                        setCtrlStatus({
                                            ...ctrlStatus,
                                            isUpdating: false,
                                            showSuccess: false,
                                            showFavoriteLists: false,
                                            showAddToFavoriteButton: true,
                                        })
                                    }
                                >
                                    <div className="text-info bg-success favorites-updated-message">
                                        <a href={`/Shop/FavoriteList/${listId}`}>
                                            <div>Favorites Updated!</div>
                                            <div>View List</div>
                                        </a>
                                    </div>
                                </PVExpire>
                            )}
                            {showCloseFavoritesSpinner && (
                                <div className="pv-spinner xs" />
                            )}
                        </React.Fragment>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

PVAddToFavorite.propTypes = {
    apiRefreshProfileMenus: PropTypes.func.isRequired,
    itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    parentName: PropTypes.string.isRequired,
    quantity: PropTypes.string.isRequired,
    spinnerHasBeenClicked: PropTypes.bool.isRequired,
    enableControl: PropTypes.bool,
    isUserRetail: PropTypes.bool.isRequired,
    favoriteListId: PropTypes.string,
};

PVAddToFavorite.defaultProps = {
    enableControl: true,
    favoritelistId: 0,
};

const mapStateToProps = (state) => {
    return {
        isUserRetail: selectUserIsRetail(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        apiRefreshProfileMenus: () => dispatch(refreshProfileMenus('PVAddToFavorite', 0)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PVAddToFavorite);
